import { apiCall } from "../../utilities/apiCall";
import { API_AR_CARD_DETAILS, API_CLIENT_SETTINGS_GET, API_CRM_CONTACTS_SECTION_CONTROL_ACCESS_GET, API_MASTER_DATA } from "../../utilities/apiUrls";
import { API_CRM_CONTACTS_SEARCH_GET_INVOICE_INFO } from "../../components/ContactSearch/urlList";
import { getSessionValue } from "../../utilities/commonHelpers";

// gets all the saved cards of different gateways if the paymentGatewayID is 0 or negative
export const getSavedCardDetails = (contactID, fromPage, paymentGatewayID = 0) => {
    return new Promise((resolve, reject) => {apiCall(API_AR_CARD_DETAILS + "/" + contactID + "/" + paymentGatewayID + "/" + fromPage)
    .then((resp) => {
            resolve(resp);
    })
    .catch((error) => {
        console.log(error);
        reject(error);
    });
});
};

export const removeStoredCard = (contactID, gatewayMerchantID, _headers = {}) => {
    let apiURL = API_AR_CARD_DETAILS;
    if(Object.keys(_headers).length > 0){
        apiURL +=  "/"+Object.keys(_headers)[0].split("_")[0];
    }
    return apiCall(`${apiURL}/${contactID}/TMM,/${gatewayMerchantID}`, "DELETE");
};

export const getSecutiryDetails = (userID) => {
    return apiCall(API_CRM_CONTACTS_SEARCH_GET_INVOICE_INFO + userID);
};

export function getClientSettings(clientID) {
    return new Promise((resolve, reject) => {
        const apiURLtoGetClientSettings = `${API_CLIENT_SETTINGS_GET}${clientID}/false/DateFormat,CurrencySymbol,CPCompanyName,mm_address [ClientAddress],CustomerPortalLogo,CultureInfo,CultureUI,IsCloudCommunicationEnabled`;
        apiCall(apiURLtoGetClientSettings, "GET")
            .then((resp) => {
                if (resp.content.Status === "Success") {
                    const responseData = resp.content.Data === null ? {} : resp.content.Data;
                    resolve(responseData);
                } else {
                    reject(resp.content.Messages[0].Message);
                }
            })
            .catch((error) => {
                console.log(error);
                reject(error);
            });
    });
}

export function fetchContactEditData(gsCustomersID,userID){
    return apiCall(
        `/services/Crm/Contacts/EditDetails/${gsCustomersID}/${userID ? userID : getSessionValue("UserID")}`,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        "#contactedit"
      );
}

export function loadProducts() {
  // {subProductTypeID:int}/{isSecurityNeeded:bool?}/{productID:int?}/{isActive:int?} --> -1/true/-1/1
  return apiCall(`/services/Admin/Products/Master/-1/true/-1/1`, "GET");
};

export function loadBusinessUnits() {
    return new Promise((resolve, reject) => {
        const apiURLtoGetBusinessUnits = "/services/Admin/BusinessUnits/Products"
        apiCall(apiURLtoGetBusinessUnits).then(resp => {
            const responseData = resp?.content?.List;
            resolve(responseData);
        }).catch((error) => {
            console.log(error);
            reject(error);
        });
    })
}

export function loadControlVisibilitySettings(payload) {
    
    return new Promise((resolve, reject) => {
        apiCall(API_CRM_CONTACTS_SECTION_CONTROL_ACCESS_GET, "POST",payload)
        .then((resp) => {
            let ControlVisibilitySettings = resp?.content?.Data?.SectionControl || [];
            resolve(ControlVisibilitySettings);
        })
        .catch((error) => {
            console.log(error);
            resolve([]);
        });
    })
}

export function fetchCustomRequiredFields(gsCustomersID){
    return apiCall(
        `/services/CRM/Contacts/Fields/Required/${gsCustomersID}`,
      );
}

export function fetchContactType() {
    return apiCall(`/services/admin/ContactType/masterdata/`)
  }
  
  export function fetchPriority() {
    return apiCall(`${API_MASTER_DATA}/Priority`);
  }

  export function fetchCategories(){
      return apiCall(`${API_MASTER_DATA}/Categories`);
  }

  export function fetchRepType(gsCustomersID = -1) {
    return apiCall(`/services/User/Accounts/Master/${parseInt(getSessionValue("UserID"))}/false/${true}/-2/${gsCustomersID}`);
  }
  export const fetchPartnerReps = (gsCustomersID) =>{
   return apiCall(`/services/User/Contacts/PartnerReps/${getSessionValue("UserID")}/${gsCustomersID}`);
  }

export function getContactJobs(gsCustomersID,subProductType) {
    return apiCall('/services/crm/contact/jobs/'+ gsCustomersID+'/'+subProductType,'GET')
}

export function getProductAndBUTagsData(ID) {
    return apiCall(`/services/crm/contacts/tags/${ID}`, "GET");
};